// extracted by mini-css-extract-plugin
export var modalBox = "G_vJ";
export var backdrop = "G_vK";